// extracted by mini-css-extract-plugin
module.exports = {"label":"LabelDefaults_label__M4yWm"};